export const fetchLibrarySurveyQuestions = resp => ({
  type: 'FETCH_LIBRARY_SURVEY_QUESTION',
  payload: resp,
});

export const fetchProfileSurveyQuestions = resp => ({
  type: 'FETCH_PROFILE_SURVEY_QUESTION',
  payload: resp,
});